// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__5vTmR","color_inherit":"Anchor_color_inherit__WE3Ie","color_link":"Anchor_color_link__GZQC2"};